import { numberFormat } from "../../../util/currency-formatter";
import { Link } from "react-router-dom";
import { PURCHASE_ORDER, SUPPLIERS } from "../../../constants/route-paths";
import { ValidatorTypes } from "../../../util/validators";


export const createPOFields = {
    workType: {
        name: "workType",
        value: "",
        error: false,
        items: [{ key: "Project", value: "project" }],
        type: "select",
        valid: true,
        dataCy: "work-type-select-input",
        validation: [],
    },
    project: {
        name: "project",
        value: "",
        error: false,
        items: [],
        type: "select",
        valid: true,
        dataCy: "select-project",
        validation: [ValidatorTypes.REQUIRED],
    },
    quote_no: {
        name: "quote_no",
        label: "Quote No",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "quote-no-input",
        validation: [],
    },
    intendedCostAttribution: {
        name: "intendedCostAttribution",
        label: "Intended Cost Attribution",
        value: "",
        error: false,
        items: [],
        type: "select",
        valid: true,
        dataCy: "select-intended-cost-attribution",
        validation: [ValidatorTypes.OPTIONAL],
    },
    tasksList: {
        name: "tasksList",
        label: "Add Items From Project",
        value: "",
        error: false,
        items: [],
        type: "select",
        valid: true,
        dataCy: "select-tasks-list",
        validation: [ValidatorTypes.OPTIONAL],
    },
    vendor: {
        name: "vendor",
        value: "",
        error: false,
        items: [],
        type: "select",
        valid: true,
        dataCy: "select-vendor",
        validation: [ValidatorTypes.REQUIRED],
    },
    deliveryOption: {
        name: "deliveryOption",
        value: "",
        error: false,
        items: [],
        type: "select",
        valid: true,
        dataCy: "select-delivery-option",
        validation: [ValidatorTypes.OPTIONAL],
    },
    deliveryDate: {
        name: "deliveryDate",
        value: "",
        error: false,
        items: [],
        type: "datepicker",
        valid: true,
        dataCy: "delivery-date-input",
        validation: [ValidatorTypes.REQUIRED],
    },
     orderDate: {
        name: "orderDate",
        value: "",
        error: false,
        items: [],
        type: "datepicker",
        valid: true,
        dataCy: "delivery-date-input",
        validation: [ValidatorTypes.REQUIRED],
    },
    notes: {
        name: "notes",
        value: "",
        error: false,
        items: [],
        type: "textarea",
        valid: true,
        dataCy: "notes-input",
        validation: [ValidatorTypes.OPTIONAL, ValidatorTypes.TEXTAREA],
    },
    street_address: {
        name: "street_address",
        label: "Street Address",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "street-address-input",
        validation:  [ValidatorTypes.OPTIONAL],
    },
    suburb: {
        name: "suburb",
        label: "Suburb",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "suburb-input",
        validation:  [ValidatorTypes.OPTIONAL],
    },
    state: {
        name: "state",
        label: "State",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "state-input",
        validation:  [ValidatorTypes.OPTIONAL],
    },
    postcode: {
        name: "postcode",
        label: "Post Code",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "postcode-input",
        validation:  [ValidatorTypes.OPTIONAL],
    },
    country: {
        name: "country",
        label: "Country",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "country-input",
        validation:  [ValidatorTypes.OPTIONAL],
    },
}

export const poListColumns = [
    {
        title: "PO Number",
        field: "id",
        render: (rowData) => (
            <Link to={`/${SUPPLIERS}/${PURCHASE_ORDER}/view/${rowData.poId}/project`}>
                {rowData.id}
            </Link>
        ),
    },
    { title: "Vendor", field: "vendorName" },
    // {
    //   title: "Vendor Type",
    //   field: "type",
    //   render: (rowData) =>
    //     rowData.type === "Supplier" ? "Supplier" : "Contractor",
    // },
    {
        title: "PO Address",
        field: "address",
    },
    {
        title: "Project",
        field: "project",
    },
    { title: "Issue Date", field: "issueDate" },
    {
        title: "Total",
        field: "total",
        class: 'text-right',
        render: (rowData) => `${numberFormat(rowData.total)}`,
    },
    {
        title: "Status",
        field: "status",
        render: (rowData) => <span className={rowData.status == 'Pending' ? 'text-warning' : rowData.status == 'Completed' ? 'text-success' : ''}>{rowData.status}</span>,
    },
]